/**Dependencies */
import React,{ useRef } from 'react'

/**Components */
import { useOnClickOutside } from '../hooks/useOnClickOutside';

/**Images */
import {FaMale, FaChild } from "react-icons/fa";

/**Styles */
import '../styles/roomsSelector.scss'

export const RoomsSelector = ({showSelector, setShowSelector, roomsData, setArrRooms}) => {
    const ref = useRef();
    
    useOnClickOutside(ref, () => {
      setShowSelector("none");
    });

    /**
     * Agrega una habitación a la lista de habitaciones seleccionadas.
     * 
     * @param {Event} e - El evento de click en el botón de agregar habitación.
     */
    const addRoom = (e) => {
      e.preventDefault();
      if (roomsData.length < 9) {
        setArrRooms([...roomsData, { id: roomsData.length + 1, adults: 1, minors: 0, ages: [] }]);
      }
    };
  
    /**
     * Elimina la última habitación de la lista de habitaciones seleccionadas.
     * 
     * @param {Event} e - El evento de click en el botón de eliminar habitación.
     */
    const removeLastRoom = (e) => {
      e.preventDefault();
      if (roomsData.length > 1) {
        setArrRooms(roomsData.slice(0, -1)); // Elimina la última habitación
      }
    };
  
    /**
     * Actualiza la cantidad de adultos o menores en una habitación.
     * 
     * @param {number} id - El ID de la habitación a actualizar.
     * @param {"adults"|"minors"} type - El tipo de huésped a actualizar (adultos o menores).
     * @param {number} delta - El delta de la cantidad de huéspedes a agregar o eliminar.
     */
    const updateGuests = (id, type, delta) => {
      setArrRooms(
        roomsData.map((room) => {
          if (room.id === id) {
            const totalGuests = room.adults + room.minors; // Total de personas en la habitación
            let newCount = room[type] + delta;
    
            // Restricción: mínimo 1 adulto por habitación
            if (type === "adults" && newCount < 1) {
              return room;
            }
    
            // Restricción: máximo 4 pax en total
            if (totalGuests + delta > 4 || newCount < 0) {
              return room;
            }
    
            if (type === "minors") {
              const newAges = newCount > room.ages.length
                ? [...room.ages, 0] // Agrega un menor con edad inicial 0
                : room.ages.slice(0, newCount); // Elimina edades excedentes
              return { ...room, minors: newCount, ages: newAges };
            }
    
            return { ...room, [type]: newCount };
          }
          return room;
        })
      );
    };
  
/**
 * Updates the age of a minor in a specific room.
 * 
 * @param {number} roomId - The ID of the room where the minor's age needs to be updated.
 * @param {number} index - The index of the minor in the room's ages array.
 * @param {number} age - The new age to be set for the minor.
 */
  const updateMinorAge = (roomId, index, age) => {
    setArrRooms(
      roomsData.map((room) =>
        room.id === roomId
          ? {
              ...room,
              ages: room.ages.map((a, i) => (i === index ? age : a)),
            }
          : room
      )
    );
  };

  return (
    <>
      <div className="rooms-selector" style={{display:showSelector}} ref={ref}>
        <div className="rooms-selector__rooms-container">
            <div className="mb-2">
                <div className="rooms-selector__noticie-rooms">
                    <i className="fa fa-info-circle"></i>
                    <p>Huéspedes máximos por habitación: 4.</p>
                </div>
            </div>
            <div className="rooms-selector__select-rooms">
                <div className="col-12 col-lg-12 mb-4 d-block d-lg-none">
                    <div className="d-flex justify-content-between mb-2">
                        <button className="btn-selector add add-habitacion" onClick={(e)=>addRoom(e)}>Agregar</button>
                        <button className="btn-selector delete delete-habitacion" onClick={(e)=>removeLastRoom(e)}>Eliminar</button>
                    </div>
                </div>
                {roomsData?.map((roomInfo, key)=>{
                    return(
                    <div className="col-12  mb-2" key={key}>
                        <div className="row appendhab">
                            <div className="col-md-12 mb-3 hab1">
                                <div className="rooms-selector__rooms">
                                    <h5>Habitación {key+1}</h5>
                                    <div className="rooms-selector__borde-hab">
                                        <div className="row">
                                            <div className="col-12 col-lg-12 text-center mt-2 mb-2">
                                                <div className="row">
                                                    <div className="col-5 col-lg-5">
                                                        <h6 style={{fontSize:"14px"}}><FaMale style={{fontSize:"18px"}}/> Adultos
                                                        </h6>
                                                    </div>
                                                    <div className="col-7 col-lg-7">
                                                        <button className="rooms-selector__button-persona menosadulto" data-habitacion={roomInfo.room} onClick={(e)=>{e.preventDefault(); updateGuests(roomInfo.id, "adults", -1);}}>-</button>
                                                        <span className="rooms-selector__number-pax adultos-hab1">{roomInfo.adults}</span>
                                                        <input type="hidden" name="adultos-hab1" value="2" data-has-listeners="true"/>
                                                        <button className="rooms-selector__button-persona masadulto" data-habitacion={roomInfo.room} onClick={(e)=>{e.preventDefault(); updateGuests(roomInfo.id, "adults", 1);}} disabled={roomInfo.adults + roomInfo.minors >= 4}>+</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-lg-12 text-center mb-2">
                                                <div className="row">
                                                    <div className="col-5 col-lg-5">
                                                        <h6 style={{fontSize:"14px"}}><FaChild style={{fontSize:"18px"}}/> Menores
                                                        </h6>
                                                    </div>
                                                    <div className="col-7 col-lg-7">
                                                        <button className="rooms-selector__button-persona menosmenor" data-habitacion="1" onClick={(e)=>{e.preventDefault(); updateGuests(roomInfo.id, "minors", -1);}}>-</button>
                                                        <span className="rooms-selector__number-pax menores-hab1">{roomInfo.minors}</span>
                                                        <input type="hidden" name="menores-hab1" value="0" data-has-listeners="true" />
                                                        <button className="rooms-selector__button-persona masmenor" data-habitacion="1" onClick={(e)=>{e.preventDefault(); updateGuests(roomInfo.id, "minors", 1);}}>+</button>
                                                    </div>
                                                </div> 
                                            </div>
                                        </div>
                                    </div> 
                                    { roomInfo.minors > 0 &&
                                        <div className="row div-menores-hab1 mt-3">
                                          {roomInfo.ages.map((age, index) => (
                                            <div className="col menor menor1-hab1">
                                              <h6>Edad menor {index + 1}</h6>
                                              <select className="form-control" name="edadmenor1-hab1" value={age} onChange={(e) => updateMinorAge(roomInfo.id, index, parseInt(e.target.value))}>
                                              {[...Array(18).keys()].map((num) => (
                                                <option key={num} value={num}>
                                                  {num}
                                                </option>
                                              ))}
                                              </select>
                                          </div>
                                          ))}                                            
                                        </div>                                       
                                    }                                   
                                                                                                                                                                                        
                                </div>
                            </div>
                        </div>
                    </div>)
                })}
                
                <div className="col-12  col-md-12 mb-4">
                    <div className="row">
                        <div className="col-12 col-lg-12 d-none d-lg-block">
                            <div className="d-flex justify-content-between mb-2">
                                <button className="btn-selector add add-habitacion" onClick={(e)=>addRoom(e)}>Agregar</button>
                                <button className="btn-selector delete delete-habitacion" onClick={(e)=>removeLastRoom(e)}>Eliminar
                                </button> 
                            </div>
                        </div>
                        <div className="col-12 col-lg-12 text-center">
                            <button className="btn-blue text-white btn w-100" onClick={(e)=>{e.preventDefault(); setShowSelector("none");}}>Confirmar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>           
    </>
  )
}
